/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationOr } from '../../models/organization-or';

export interface GetReverseTreeOfTenant$Params {
  orid: number;
  meid: number;
}

export function getReverseTreeOfTenant(http: HttpClient, rootUrl: string, params: GetReverseTreeOfTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationOr>>> {
  const rb = new RequestBuilder(rootUrl, getReverseTreeOfTenant.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
    rb.path('meid', params.meid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OrganizationOr>>;
    })
  );
}

getReverseTreeOfTenant.PATH = '/api/Organizations/reversetreeoftenant/{orid}/{meid}';
